import api from "./api";

export default class ArticleApi {
  static async GetList(data) {
    return api.get(`article`, data);
  }
}
